import { ChevronDown } from 'lucide-react';
import { ReactNode } from 'react';

interface StageSectionProps {
  label: string;
  expanded: boolean;
  onToggle: () => void;
  collapsedSummary: ReactNode;
  headerActions?: ReactNode;
  children: ReactNode;
}

export default function StageSection({
  label,
  expanded,
  onToggle,
  collapsedSummary,
  headerActions,
  children,
}: StageSectionProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={onToggle}
          className="flex items-center gap-2 group"
        >
          <ChevronDown
            className={`size-4 text-muted-foreground transition-transform ${expanded ? '' : '-rotate-90'}`}
          />
          <span className="label-caps text-xs text-muted-foreground group-hover:text-foreground transition-colors">
            {label}
          </span>
          {!expanded && (
            <span className="text-xs text-muted-foreground/80 ml-2">
              {collapsedSummary}
            </span>
          )}
        </button>
        {expanded && headerActions && (
          <div className="flex items-center gap-2">{headerActions}</div>
        )}
      </div>
      {expanded && <div>{children}</div>}
    </div>
  );
}
